<div class="dispatch-schedule-component">
  <div class="col-md-12 no-padding">
    <!-- Tab Navigation -->
    <ul class="nav nav-tabs">
      <li
        class="nav-item"
        [class.active]="activeTab === 'driver-assignments'"
        *ngIf="
          isFeatureEnabled('dispatchDriverAssignments') &&
          hasPermission('DispatchDriverAssignmentsRead')
        "
      >
        <a
          class="nav-link"
          (click)="setActiveTab('driver-assignments')"
          [class.active]="activeTab === 'driver-assignments'"
        >
          Driver Assignments
        </a>
      </li>
      <li
        class="nav-item"
        [class.active]="activeTab === 'dispatch-finder'"
        *ngIf="isFeatureEnabled('dispatchFinder') && hasPermission('DispatchFinderRead')"
      >
        <a
          class="nav-link"
          (click)="setActiveTab('dispatch-finder')"
          [class.active]="activeTab === 'dispatch-finder'"
        >
          Dispatch Finder
        </a>
      </li>
    </ul>

    <!-- Tab Content -->
    <div class="tab-content">
      <app-dispatch-driver-assignments
        *ngIf="
          activeTab === 'driver-assignments' &&
          isFeatureEnabled('dispatchDriverAssignments') &&
          hasPermission('DispatchDriverAssignmentsRead')
        "
      ></app-dispatch-driver-assignments>
      <app-dispatch-finder
        *ngIf="
          activeTab === 'dispatch-finder' &&
          isFeatureEnabled('dispatchFinder') &&
          hasPermission('DispatchFinderRead')
        "
      ></app-dispatch-finder>
    </div>
  </div>
</div>
